export enum FeaturedCarouselType {
  Product = 'product',
  Retailer = 'retailer',
}
